export default "__VITE_ASSET__CmrRI1w9__"